import { useQuery } from '@tanstack/react-query';

// common
import useService from 'common/hook/useService';
import { handleException } from 'modules/account/detail/helpers/utils';

// screen
import type { ReplaceOtherDocument } from 'modules/suppliers/types';

// export type OtherDocument = typeof schemas.DocumentFromKios._type;
export type OtherDocument = ReplaceOtherDocument;

interface UseOtherDocumentsProps {
  supplierProfileOperationCode?: string;
  customerOperationCode?: string;
}

const useOtherDocuments = (props: UseOtherDocumentsProps) => {
  const { supplierProfileOperationCode, customerOperationCode } = props;
  const service = useService();

  return useQuery({
    queryKey: ['otherDocuments', supplierProfileOperationCode, customerOperationCode],
    queryFn: async () => {
      try {
        if (!service || !supplierProfileOperationCode || !customerOperationCode) {
          return null;
        }

        const res: OtherDocument[] =
          await service.SupplierProfileController_listDocumentBySupplierProfile({
            params: {
              customerOperationCode,
              supplierProfileOperationCode,
            },
            queries: {
              supplierProfileOperationCode,
            } as { pageIndex?: number; pageSize?: number; sorts?: string },
          });

        return res;
      } catch (error) {
        handleException(error);
      }
    },
  });
};

export default useOtherDocuments;
